.depth-wrap {
  border: none;
  border-radius: 0;
  height: 100%;
  width: 18.75rem;
}

.depth-header {
  display: flex;
  align-content: center;
  justify-content: space-between;
  height: 46px;
  padding: 10px 1rem;
  border: none;
}

.toggle-btn {
  width: 26px;
  height: 26px;
  outline: none;
  box-shadow: none !important;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  margin-right: 6px;
  border-radius: 0 !important;
  border: none;
  &:hover {
    background-color: rgba(9, 13, 26, 1);
  }
  &.all {
    background-image: url(./images/trade-icon-all.svg);
  }
  &.bid {
    background-image: url(./images/trade-icon-sell.svg);
  }
  &.ask {
    background-image: url(./images/trade-icon-buy.svg);
  }
}
.toggle-btn-group {
  :global {
    .btn-check:active + .btn-primary,
    .btn-check:checked + .btn-primary,
    .btn-primary.active,
    .btn-primary:active,
    .show > .btn-primary.dropdown-toggle {
      background-color: rgba(9, 13, 26, 1);
    }
  }
}
.depth-select {
  :global {
    .btn {
      height: 26px;
      border-color: transparent;
      box-shadow: none !important;
    }
    .dropdown-menu {
      width: 80px;
      min-width: 80px;
    }
  }
}

.trade-list-header {
  margin-bottom: 0;
  height: 32px;
  padding: 0 1rem;
  white-space: nowrap;
  font-size: 12px !important;
  & > .title-item {
    width: 33.33%;
    color: #5f7195;
    text-align: right;
  }
  & > .title-item:first-child {
    text-align: left;
  }
  .badge {
    background-color: rgba(33, 42, 69, 1) !important;
    font-weight: 400;
  }
}
.trade-list-sell,
.trade-list-buy,
.no-data {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  color: #f4f9ff !important;
  min-height: 300px;
  font-family: Poppins-Regular, Poppins;
}
.no-data {
  align-items: center;
  justify-content: center;
  color: #5f7195 !important;
}
.trade-list-sell {
  margin-top: auto;
}
.depth-body {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
}
.depth-all .trade-list-sell {
  margin-top: 0;
}

.trade-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  height: 30px;
  padding: 0 1rem;
  border: none;
  background-position: 100%;
  background-repeat: no-repeat;
  color: #fff;
  border-radius: 0 !important;
  &:hover {
    background-color: rgba(37, 42, 68, 0.5) !important;
  }
  & > span {
    width: 33.33%;
    text-align: right;
  }
  .trade-list-price {
    text-align: left;
  }
}
.trade-list-sell {
  justify-content: flex-end;
  .trade-list-price {
    color: #ec4953;
  }
  .trade-list-item {
    background-image: linear-gradient(
      rgba(236, 73, 83, 0.1),
      rgba(236, 73, 83, 0.1)
    );
  }
}
.trade-list-buy {
  .trade-list-price {
    color: #0fbeaf;
  }
  .trade-list-item {
    background-image: linear-gradient(
      rgba(18, 184, 134, 0.1),
      rgba(18, 184, 134, 0.1)
    );
  }
}

.price-wrap {
  height: 36px;
  line-height: 36px;
  padding-left: 10px;
  color: #5f7195;
  .price {
    font-size: 18px;
    font-weight: 500;
    &.green {
      color: #0fbeaf;
    }
    &.red {
      color: #ec4953;
    }
    &.white {
      color: #ffffff;
    }
  }
}
